const keyLookup = {
  "`": {},
  "1": {},
  "2": {},
  "3": {},
  "4": {},
  "5": {},
  "6": {},
  "7": {},
  "8": {},
  "9": {},
  "0": {},
  "-": { Dvorak: "'" },
  "=": { Dvorak: "]" },
  "~": {},
  "!": {},
  "@": {},
  "#": {},
  "$": {},
  "%": {},
  "^": {},
  "&": {},
  "*": {},
  "(": {},
  ")": {},
  "_": { Dvorak: '"' },
  "+": { Dvorak: "}" },

  "q": { Dvorak: "x" },
  "w": { Dvorak: ",", QGMLWY: "t" },
  "e": { Dvorak: "d", Colemak: "k", QWYRFM: "k", QGMLWY: "k" },
  "r": { Dvorak: "o", Colemak: "s", QGMLWY: "g" },
  "t": { Dvorak: "k", Colemak: "f", QWYRFM: "f", QGMLWY: "d" },
  "y": { Dvorak: "t", Colemak: "o", QWYRFM: "e", QGMLWY: "u" },
  "u": { Dvorak: "f", Colemak: "i", QWYRFM: "i", QGMLWY: "i" },
  "i": { Dvorak: "g", Colemak: "l", QWYRFM: "l", QGMLWY: "h" },
  "o": { Dvorak: "s", Colemak: ";", QWYRFM: "j", QGMLWY: "l" },
  "p": { Dvorak: "r", Colemak: "r", QGMLWY: "m" },
  "[": { Dvorak: "-" },
  "]": { Dvorak: "=" },
  "\\": {},
  "Q": { Dvorak: "X" },
  "W": { Dvorak: "<", QGMLWY: "T" },
  "E": { Dvorak: "D", Colemak: "K", QWYRFM: "K", QGMLWY: "K" },
  "R": { Dvorak: "O", Colemak: "S", QGMLWY: "G" },
  "T": { Dvorak: "K", Colemak: "F", QWYRFM: "F", QGMLWY: "D" },
  "Y": { Dvorak: "T", Colemak: "O", QWYRFM: "E", QGMLWY: "U" },
  "U": { Dvorak: "F", Colemak: "I", QWYRFM: "I", QGMLWY: "I" },
  "I": { Dvorak: "G", Colemak: "L", QWYRFM: "L", QGMLWY: "H" },
  "O": { Dvorak: "S", Colemak: ":", QWYRFM: "J", QGMLWY: "L" },
  "P": { Dvorak: "R", Colemak: "R", QGMLWY: "M" },
  "{": { Dvorak: "_" },
  "}": { Dvorak: "+" },
  "|": {},

  "a": { QWYRFM: "d", QGMLWY: "j" },
  "s": { Dvorak: ";", Colemak: "d" },
  "d": { Dvorak: "h", Colemak: "g", QWYRFM: "a", QGMLWY: "a" },
  "f": { Dvorak: "y", Colemak: "e", QWYRFM: "t", QGMLWY: "u" },
  "g": { Dvorak: "u", Colemak: "t", QWYRFM: "n", QGMLWY: "w" },
  "h": { Dvorak: "j", Colemak: "h", QGMLWY: ";" },
  "j": { Dvorak: "c", Colemak: "y", QWYRFM: "b", QGMLWY: "b" },
  "k": { Dvorak: "v", Colemak: "n", QWYRFM: "m", QGMLWY: "n" },
  "l": { Dvorak: "p", Colemak: "u", QWYRFM: "u", QGMLWY: "r" },
  ";": { Dvorak: "z", Colemak: "p", QGMLWY: "p" },
  "'": { Dvorak: "q" },
  "A": { QWYRFM: "D", QGMLWY: "J" },
  "S": { Dvorak: ":", Colemak: "D" },
  "D": { Dvorak: "H", Colemak: "G", QWYRFM: "A", QGMLWY: "A" },
  "F": { Dvorak: "Y", Colemak: "E", QWYRFM: "T", QGMLWY: "U" },
  "G": { Dvorak: "U", Colemak: "T", QWYRFM: "N", QGMLWY: "W" },
  "H": { Dvorak: "J", Colemak: "H", QGMLWY: ":" },
  "J": { Dvorak: "C", Colemak: "Y", QWYRFM: "B", QGMLWY: "B" },
  "K": { Dvorak: "V", Colemak: "N", QWYRFM: "M", QGMLWY: "N" },
  "L": { Dvorak: "P", Colemak: "U", QWYRFM: "U", QGMLWY: "R" },
  ":": { Dvorak: "Z", Colemak: "P", QGMLWY: "P" },
  '"': { Dvorak: "Q" },

  "z": { Dvorak: "/" },
  "x": { Dvorak: "b" },
  "c": { Dvorak: "i" },
  "v": { Dvorak: "." },
  "b": { Dvorak: "n", QWYRFM: "o", QGMLWY: "o" },
  "n": { Dvorak: "l", Colemak: "j", QWYRFM: "g", QGMLWY: "f" },
  "m": { QWYRFM: "y", QGMLWY: "e" },
  ",": { Dvorak: "w" },
  ".": { Dvorak: "e" },
  "/": { Dvorak: "[" },
  "Z": { Dvorak: "?" },
  "X": { Dvorak: "B" },
  "C": { Dvorak: "I" },
  "V": { Dvorak: ">" },
  "B": { Dvorak: "N", QWYRFM: "O", QGMLWY: "O" },
  "N": { Dvorak: "L", Colemak: "J", QWYRFM: "G", QGMLWY: "F" },
  "M": { QWYRFM: "Y", QGMLWY: "E" },
  "<": { Dvorak: "W" },
  ">": { Dvorak: "E" },
  "?": { Dvorak: "{" },
  " ": {}
};

export default function translateText(text, layout) {
  let output = "";
  for (let char of text) {
    if (layout in keyLookup[char]) {
      output += keyLookup[char][layout];
    } else {
      output += char
    }
  }
  return output;
};